import React, { useState } from 'react';
import DeviceIcons from '../deviceList/DeviceIcons';
import LastEventInfo from './LastEventInfo';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import Modal from '../components/Modal';
import Chartjs from '../components/Chart/Chart';
import { LeakAlarmStatus } from '../features/Devices/leakAlarm';

const Sensor = ({ device, timeZone }) => {
  const [showModal, setShowModal] = useState(false);

  const { type, serial_number, last_event } = device;
  const { sub_type } = type;
  const isLeakage = sub_type?.key === 'sensor:water:leakage';
  const hasLastEvent = !isNaN(new Date(last_event?.at));

  return (
    <div className="bg-white first:rounded-tl-3xl cursor-pointer rounded-3xl last:rounded-br-3xl p-5 border-l select-none tap-highlight-transparent flex flex-col justify-between h-full">
      <div className="flex gap-x-4 items-center">
        <DeviceIcons device={device} />
        <div className="min-w-0">
          <p className="truncate">{type?.name}</p>
          <p className="truncate text-sm text-gray-400">{serial_number}</p>
        </div>
      </div>

      <div className="mt-2 flex-1">
        <div className="truncate text-xs text-gray-400">
          <LastEventInfo device={device} />
        </div>
      </div>

      {(isLeakage || hasLastEvent) && (
        <div className="mt-2 flex items-end gap-3">
          <div className="min-w-0 flex-1">
            <p className="mb-1 text-sm text-gray-500">Датчик</p>
            <div className="text-gray-800 text-base xl:text-lg">
              {isLeakage && <LeakAlarmStatus deviceId={device.id} timeZone={timeZone} />}
              {sub_type?.key === 'sensor:temperature' && (
                <p className="lg:text-xl xl:text-2xl">{(last_event?.value ? last_event?.value : '-') + ' °C'}</p>
              )}
            </div>
          </div>
          {hasLastEvent && (
            <div
              onClick={() => setShowModal(true)}
              className="shrink-0 flex items-center justify-center bg-gray-100 hover:bg-gray-200 rounded-full p-2"
              id="icon-chart">
              <QueryStatsIcon className="text-orange-500 w-6 h-6 xl:w-7 xl:h-7" />
            </div>
          )}
        </div>
      )}

      <div id="modal-chart">
        <Modal classWidth={'relative w-11/12 xl:w-1/2 my-6 mx-3'} showModal={showModal} setShowModal={setShowModal} title="История данных устройства">
          <Chartjs device={device} timeZone={timeZone} />
        </Modal>
      </div>
    </div>
  );
};

export default Sensor;
